import { sortBy } from 'lodash'

export const getIsModifierGroupsLoading = (state) =>
  state?.modifierGroups?.isLoading ?? false

export const getModifierGroups = (state) =>
  sortBy(Object.values(state?.modifierGroups?.byId ?? {}), [
    'sortOrder',
    'name',
  ])

export const getCurrentModifierGroup = (state, uuid) =>
  state?.modifierGroups?.byId?.[uuid] ?? {}

export const getSearchModifierGroupsValue = (state) =>
  state?.modifierGroups?.filters?.searchModifierGroupsValue ?? ''

export const getModifierGroupsSortingMode = (state) =>
  state?.modifierGroups?.modifierGroupsSortingMode ?? false

export const getModifierGroupsIndexes = (state) =>
  state?.modifierGroups?.modifierGroupsIndexes ?? []
